import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api/api.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StorageService } from 'src/app/services/azure/storage/storage.service';
import { Router } from '@angular/router';
import { Subscription } from '../settings/components/monetization/components/membership/membership.model';
import { AppBLL } from 'src/app/app.bll';
import { search_location } from 'src/app/components/calendar/calendar.model';
@Injectable({
  providedIn: 'root',
})
export class FieldFacilityBLL {
  //#region Loaders Observables

  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  readonly isLoading$: Observable<boolean> = this.isLoading.asObservable();

  private isAddFacilityModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isAddFacilityModelOpen$: Observable<boolean> =
    this.isAddFacilityModelOpen.asObservable();

  private isUpdateFacilityModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isUpdateFacilityModelOpen$: Observable<boolean> =
    this.isUpdateFacilityModelOpen.asObservable();


  private facilities: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly facilities$: Observable<any> = this.facilities.asObservable();


  private facility: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly facility$: Observable<any> = this.facility.asObservable();

  private creation_status: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);
  readonly creation_status$: Observable<string> =
    this.creation_status.asObservable();

  selectedFacility$: Subject<any> = new Subject<any>();

  private isLocationsSearchLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly isLocationsSearchLoading$: Observable<boolean> = this.isLocationsSearchLoading.asObservable();

  private search_locations_response: BehaviorSubject<search_location[]> = new BehaviorSubject<search_location[]>([]);
  readonly search_locations_response$: Observable<search_location[]> = this.search_locations_response.asObservable();

  //#endregion Data Observables

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private storage: StorageService,
    // private memberBLL: MembershipBLL,
    private appBll: AppBLL,
    private router: Router
  ) { }

  public getFacilities(ad_admin_id: string = null) {
    this.isLoading.next(true);

    let url = `field-events?type=get_all_field_facilities`;

    if (ad_admin_id) {
      url += `&admin_id=${ad_admin_id}`;
    }

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.facilities.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }


  public getFacility() {
    this.isLoading.next(true);

    let url = `field-events?type=get_field_facility`;

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.facility.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }

  // public getFacilityById(id) {


  //   this.isLoading.next(true);

  //   let url = `field-events?type=get_all_field_facilities`;

  //   this.api
  //     .get(url)
  //     .pipe(take(1))
  //     .subscribe(
  //       (response: any) => {
  //         this.facilities.next(response);
  //         this.isLoading.next(false);
  //         this.selectedFacility$.next(id);
  //         // console.log('selected facility', this.selectedFacility$);

  //       },
  //       (err) => {
  //         this.isLoading.next(false);
  //       }
  //     );


  // }

  public async createFacility(facility, admin_id: string = null) {
    this.isLoading.next(true);

    let url = `field-events?type=post_field_facility`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.api
      .post(url, facility)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.creation_status.next('success');
          this.selectedFacility$.next(response.data.id);
          // this.getFacilityById(response.data.id);
          this.toast.showToast('Success!', 'Facility has been created.');
          this.toggleAddFacilityModel(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }



  public async deleteFacility(id: string, admin_id: string = null) {
    let url = `field-events?type=delete_field_facility&id=${id}`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.api.delete(url).subscribe(
      async () => {
        this.getFacilities(admin_id);
        this.toast.showToast('Success!', 'Facility has been deleted.');
      },
      async (err) => {
        console.log('HTTP Error', err);
      }
    );
  }

  public async editFacility(id, facility, admin_id: string = null) {
    let url = `field-events?type=update_field_facility`;

    if (admin_id) {
      url += `&admin_id=${admin_id}`;
    }

    this.isLoading.next(true);

    let update_facility = { ...facility, id: id };

    this.api
      .patch(url, update_facility)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.toast.showToast('Success!', 'Facility has been updated.');
          this.creation_status.next('success');
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }



  toggleAddFacilityModel(isOpen: boolean) {
    this.isAddFacilityModelOpen.next(isOpen);
  }

  changeUpdateFacilityModelOpen(isOpen: boolean) {
    this.isUpdateFacilityModelOpen.next(isOpen);
  }

  search_locations(search: string) {
    this.isLocationsSearchLoading.next(true);
    const encoded = encodeURIComponent(search);
    const url = `location?search=${encoded}`;
    this.api.get(url).pipe(take(1)).subscribe((res: search_location[]) => {
      this.isLocationsSearchLoading.next(false);
      this.search_locations_response.next(res);
    }, () => {
      this.isLocationsSearchLoading.next(false);
    });
  }

  reset_search_location_response() {
    this.search_locations_response.next([]);
  }

}
